<template>
    <div class="home-wrapper">
        <Banner />
        <Intro />
        <Contact />
        <div class="bottom">
            <div class="company">杭州天目里互联网科技有限公司</div>
            <div class="beian">
                <span>Hangzhou Ooelicloud Information Technology Co., Ltd</span>
            </div>
            <div class="beian">
                <span><a href="https://temmoku2020.oss-cn-hangzhou.aliyuncs.com/20211130034520197_compressed.pdf?versionId=CAEQQBiBgICz45uF7xciIDVlZWYxOWNhMzkxMTQzMGFhNDY3NTFmNDIzZTllY2Uy" target="_blank">增值电信业务经营许可证 浙B2-20210762 </a>|</span>
                <span><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">浙ICP备 2021026487号-1 </a>|</span>
                <span><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602012135" target="_blank">浙网公备 33010602012135号 </a></span>
            </div>
            <div class="agreement">
                <a href="https://pro.api.ooelicloud.com/h5/privateInfo.html" target="_blank">隐私政策</a
                ><a href="https://pro.api.ooelicloud.com/h5/user.html" target="_blank">服务条款</a>
            </div>
        </div>
    </div>
</template>

<script>
import Banner from "./components/banner";
import Intro from "./components/intro";
import Contact from "./components/contact";
export default {
    name: "Home",
    components: {
        Banner,
        Intro,
        Contact,
    },
};
</script>

<style lang="less" scoped>
.home-wrapper {
    .bottom {
        height: 195px;
        background: #f2f2f2;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.8999999761581421);
        line-height: 14px;
        .company {
            margin-bottom: 8px;
        }
        .beian {
            margin-bottom: 8px;
            a {
                font-weight: 400;
                color: rgba(0, 0, 0, 0.9);
                cursor: pointer;
               
            }
            span {
                + span {
                    margin-left: 10px;
                }
            }
        }
        .agreement {
            a {
                font-weight: 400;
                color: rgba(0, 0, 0, 0.8999999761581421);
                cursor: pointer;
                + a {
                    margin-left: 20px;
                }
            }
        }
    }
}
</style>
